import React from "react";
import "./loading.css";

const Loading = () => {
  return (
    <>
      <svg
        className="loader"
        width="300"
        height="280"
        viewBox="0 0 500 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="500" height="600" />
        <path
          id="MagGlass"
          d="M170.844 24.4839C155.456 11.4994 136.626 3.26737 116.645 0.789564C96.6634 -1.68824 76.3928 1.69501 58.2994 10.5276C40.2061 19.3602 25.07 33.2614 14.7331 50.5395C4.39617 67.8176 -0.695911 87.7278 0.0764734 107.847C0.848857 127.966 7.4524 147.428 19.0836 163.862C30.7147 180.297 46.872 192.997 65.5893 200.416C84.3066 207.836 104.777 209.655 124.509 205.653C144.242 201.65 162.385 191.999 176.732 177.873L304.133 285.372C306.072 287.003 308.579 287.797 311.103 287.582C313.628 287.367 315.964 286.16 317.6 284.225C319.236 282.29 320.038 279.786 319.83 277.261C319.622 274.736 318.421 272.396 316.491 270.755L316.477 270.743L189.077 163.243C203.877 142.002 210.211 116 206.838 90.3317C203.465 64.6637 190.629 41.1805 170.844 24.4839V24.4839ZM162.631 152.892C152.706 164.654 139.516 173.209 124.728 177.475C109.941 181.741 94.221 181.526 79.5558 176.858C64.8906 172.19 51.9391 163.278 42.339 151.249C32.7388 139.22 26.9214 124.614 25.6222 109.278C24.323 93.9431 27.6004 78.5669 35.04 65.0943C42.4796 51.6216 53.7473 40.6576 67.4181 33.5887C81.0889 26.5198 96.5489 23.6635 111.843 25.3811C127.137 27.0986 141.579 33.3128 153.341 43.2379V43.2379C169.114 56.5469 178.954 75.5766 180.696 96.1407C182.438 116.705 175.94 137.119 162.631 152.892V152.892Z"
          fill="#3F3D56"
        />
      </svg>

      <h1 className="searching">Analyzing...</h1>
    </>
  );
};

export default Loading;
